import { createTheme } from '@mui/material/styles';

/** Aligns with QC Lite / TailAdmin brand and Tailwind `gray-900` / `gray-800` dark surfaces. */
export function createAppMuiTheme(mode) {
  const isDark = mode === 'dark';

  return createTheme({
    palette: {
      mode,
      primary: {
        main: '#24389c',
        light: '#3d52b8',
        dark: '#1e3a8a',
      },
      ...(isDark
        ? {
            background: {
              default: '#111827',
              paper: '#1f2937',
            },
            divider: 'rgba(255, 255, 255, 0.12)',
            text: {
              primary: 'rgba(255, 255, 255, 0.92)',
              secondary: 'rgba(255, 255, 255, 0.65)',
            },
          }
        : {
            background: {
              default: '#ffffff',
              paper: '#ffffff',
            },
          }),
    },
    shape: { borderRadius: 10 },
    components: {
      MuiDialog: {
        styleOverrides: {
          paper: {
            backgroundImage: 'none',
          },
        },
      },
    },
  });
}
